/* eslint-disable react-native/no-color-literals */
/* eslint-disable no-dupe-keys */
/* eslint-disable react-native/sort-styles */
import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  animatedViewContainer: {
    borderBottomEndRadius: 20,
    borderBottomLeftRadius: 20,
    overflow: "hidden",
  },
  bottomBlock: { height: 20 },
  container: { height: "100%", padding: 10 },
  contentContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 20,
    widhth: "100%",
  },
  contentDateText: {
    color: colors.placeholder,
    fontFamily: typography.primary.normal,
    fontSize: 13,
    marginTop: 5,
  },
  emptyContainer: {
    alignItems: "center",
    flex: 1,
    height: "100%",
    justifyContent: "center",
  },
  emptyTitleText: { fontFamily: typography.primary.normal, fontSize: 25, padding: 20 },
  flex: { flex: 1 },
  greenText: { color: colors.green },
  headerBottomBigContainer: {
    width: "100%",
    height: "100%",
  },
  headerBottomPointContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
  headerBottomButton: {
    display: "flex",
    flexDirection: "row",
    minWidth: 60,
    borderWidth: 2,
    borderColor: "red",
    borderRadius: 20,
    height: 35,
    alignItems: "center",
    justifyContent: "space-around",
    backgroundColor: "white",
    paddingHorizontal: 10,
  },
  headerBottomButtonImage: {
    width: 20,
    height: 20,
    resizeMode: "contain",
    marginRight: 5,
  },
  headerBottomPointText: {
    fontFamily: typography.primary.normal,
    fontSize: 16,
    width: "100%",
    height: "100%",
    textAlign: "center",
  },
  headerBottomTitleText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    fontSize: 18,
    marginTop: -20,
  },
  headerContainer: {
    alignItems: "center",
    justifyContent: "space-between",
    height: 50,
    flexDirection: "row",
  },
  headerContentContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 15,
    width: "100%",
  },
  headerIconContainer: { alignSelf: "flex-start", display: "flex", flexDirection: "row" },
  headerTopPointText: { color: colors.white, fontFamily: typography.primary.normal, fontSize: 17 },
  linearGradient: {
    borderBottomEndRadius: 20,
    borderBottomLeftRadius: 20,
    overflow: "hidden",
    paddingTop: 10,
    position: "absolute",
  },
  pointContentText: { fontFamily: typography.primary.normal },
  pointContentTitle: { fontFamily: typography.primary.normal, fontSize: 20, marginTop: 20 },
  redText: { color: colors.error },
  separator: { backgroundColor: colors.placeholder, height: 0.5 },
  pointContainer: {
    backgroundColor: colors.pivilegePointContainer,
    borderRadius: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 10,
    paddingHorizontal: 10,
    marginTop: 10,
  },
  text: { color: colors.white, fontFamily: typography.primary.normal },
  mt10: { paddingTop: 10, paddingBottom: 20 },
  mt15: { marginTop: 15 },
  voucherContainer: {
    borderRadius: 10,
    padding: 5,
    overflow: "hidden",
    shadowColor: "#000", // Optional shadow for depth
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 6,
    width: "100%",
    marginBottom: 15,
  },
  stampContainer: {
    borderRadius: 10,
    overflow: "hidden",
    shadowColor: "#000", // Optional shadow for depth
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 6,
    width: "100%",
    marginBottom: 15,
  },
  stampTextContainer: {
    padding: 5,
  },
  voucherImage: {
    alignSelf: "center",
    borderRadius: 10,
  },
  stampImage: {
    alignSelf: "center",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  unactiveFilter: {
    borderWidth: 2,
    borderRadius: 8,
    marginRight: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  unactiveFilterText: {
    marginHorizontal: 20,
  },
  activeFilter: {
    borderWidth: 2,
    borderRadius: 8,
    marginRight: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  activeFilterText: {
    marginHorizontal: 20,
    color: colors.white,
  },
  desc_text: {
    color: colors.black,
    fontFamily: typography.thin.normal,
    fontSize: 10,
  },
  stampProgressContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
    paddingVertical: 5,
    width: "100%",
  },
  stampSegment: {
    width: 20,
    height: 6,
    backgroundColor: "#E0E0E0",
    borderRadius: 2,
  },
  stampCountText: {
    fontSize: 12,
    color: colors.lightGrey,
  },
})
